var map = {
	"./assets/GT-America-Bold.woff": "2b61",
	"./assets/GT-America-Expanded-Bold.woff": "2686",
	"./assets/GT-America-Regular.woff": "5a43",
	"./assets/img/erhvervsstyrelsen/typeface.svg": "b113",
	"./assets/img/logos/react.svg": "969a",
	"./assets/img/logos/salesforce.svg": "d0a1",
	"./assets/img/logos/sitecore.png": "1026",
	"./assets/img/logos/vue.svg": "0b4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";